<div class="dialog-header tw-flex tw-justify-between">
  <h1 mat-dialog-title>Publish this option to portal?</h1>
  <mat-icon class="close tw-cursor-pointer tw-m-6" aria-hidden="false" mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content>
  <div class="tw-text-xl tw-font-semibold">
    {{ optionParentLenderName }}: {{ data?.option?.name }}
  </div>
  <div class="subheader tw-text-sm">
    Created from {{ optionParentLenderName }} {{ optionParentName }}
  </div>
  <div class="tw-mt-4">
    These are the details the borrower will see for this option:
  </div>
  <div class="option-details tw-rounded-2xl tw-py-4 tw-px-8 tw-text-base tw-leading-5 d-flex">
    <div class="details tw-flex-1">
      <div *ngIf="!data?.option?.termSet?.initialDrawAmount" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Financing amount
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          <ng-template [ngIf]="data?.option?.termSet?.amount">{{ data.option.termSet.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</ng-template>
          <ng-template [ngIf]="!data?.option?.termSet?.amount">—</ng-template>
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.initialDrawAmount" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Initial draw amount
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.initialDrawAmount | currency:'USD':'symbol-narrow':'1.0-0' }}
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.paymentAmount && paymentFrequencyShort" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Est. payment
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.paymentAmount | currency:'USD':'symbol-narrow':'1.0-0' }}/{{ paymentFrequencyShort }}
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.paymentFrequency" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Payment frequency
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.paymentFrequency | titlecase }}
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.term" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Term
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.term }} {{ termDurationFormatted }}
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.factorRate" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Factor rate
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.factorRate | number:'1.2-2' }}
        </div>
      </div>

      <div *ngIf="periodicRate" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          {{ periodicLabel }}
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ periodicRate }}
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.drawFeePercent" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Draw fee
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.drawFeePercent | number:'1.2-2' }}%
        </div>
      </div>

      <div *ngIf="data?.option?.termSet?.originationFeePercent && optionLoanCategoryType === 'term'" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Origination fee
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ data.option.termSet.originationFeePercent | number:'1.2-2' }}%
        </div>
      </div>

      <div *ngIf="costOfCapital" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Cost of capital
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ costOfCapital | currency:'USD':'symbol-narrow':'1.0-0' }}
        </div>
      </div>

      <div *ngIf="payback" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Payback amount
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ payback | currency:'USD':'symbol-narrow':'1.0-0' }}
        </div>
      </div>

      <div *ngIf="optionLoanType" class="details-row py-2 tw-flex tw-flex-row">
        <div class="detail-label tw-flex-1 tw-w-1/2">
          Loan Type
        </div>
        <div class="tw-flex-1 tw-w-1/2 tw-text-right tw-pl-2">
          {{ optionLoanType }}
        </div>
      </div>
    </div>

    <div *ngIf="data.option?.valuePropositions?.length" class="benefits tw-flex-1">
      <div class="tw-text-sm tw-font-semibold tw-mt-1 tw-mb-4">Financing benefits:</div>

      <div class="d-flex flex-column tw-gap-4">
        <div *ngFor="let valueProp of data.option.valuePropositions" class="item">
          <div class="tw-text-sm tw-mb-1">{{ valueProp.title }}</div>
          <div class="tw-text-xs tw-text-gray-500">{{ valueProp.description }}</div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="btn btn-default tw-mr-2"
    (click)="closeModal()"
  >
    Cancel
  </button>
  <button
    class="btn btn-primary"
    (click)="publishOption()"
    [disabled]="false"
  >
    Publish
  </button>
</mat-dialog-actions>
